import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';

import { LayoutNavigationConfig } from '@frontend/sports/common/client-config-data-access';

export const canMatchDynamicCategoriesGuard: CanMatchFn = (route: Route, _: UrlSegment[]) => {
    const layoutConfig = inject(LayoutNavigationConfig);
    const dynamicCategoryQuery = inject(Router).getCurrentNavigation()?.initialUrl.queryParams['dynamicCategory'];

    return layoutConfig.isDynamicCategoryNavigationEnabled && !!dynamicCategoryQuery;
};
